import React, { useEffect, useState, FC } from 'react';
import { Container } from '@goldbely/explore-component-library';
import cls from 'classnames';

import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import MobileMenuToggle from '../../../../atoms/MobileMenuToggle';
import SearchAndCart from '../../../../molecules/SearchAndCart';
import { Logo } from './atoms/Logo';
import { Links } from './molecules/Links';
import { Authentication } from './molecules/Authentication';

import styles from './index.module.sass';

interface IByrdCookieCompanyProps {
  links?: INavItem;
  merchant: IMerchant;
}

export const ByrdCookieCompany: FC<IByrdCookieCompanyProps> = ({ links, merchant }) => {
  const [ overlayLinks, setOverlayLinks ] = useState( false );
  const [ overlaySearch, setOverlaySearch ] = useState( false );

  const handleClickMenuToggle = () => {
    setOverlaySearch( false );
    setOverlayLinks(( state ) => !state );
  };

  const handleClickSearchToggle = () => {
    setOverlayLinks( false );
    setOverlaySearch(( state ) => !state );
  };

  useEffect(() => {
    const handleKeyDown = ( event: KeyboardEvent ) => {
      if ( event.key === 'Escape' ) {
        setOverlayLinks( false );
        setOverlaySearch( false );
      }
    };
    document.addEventListener( 'keydown', handleKeyDown );
    return () => {
      document.removeEventListener( 'keydown', handleKeyDown );
    };
  }, []);

  return (
    <Container className={cls( styles.container, { [styles.overlay]: overlayLinks })}>
      <div className={`${styles.mobile} ${styles.shoulder}`}>
        <MobileMenuToggle isActive={overlayLinks} onClick={handleClickMenuToggle} />
      </div>

      <Logo merchant={merchant} />

      <Links data={links} overlay={overlayLinks} />

      <div className={`${styles.buttons} ${styles.shoulder}`}>
        <Authentication />

        <SearchAndCart
          className={{ container: styles['search-and-cart'], overlay: styles['search-overlay'] }}
          overlaySearch={overlaySearch}
          onClickSearchToggle={handleClickSearchToggle}
        />
      </div>
    </Container>
  );
};
